// Comprehensive Word Dictionary with Meanings and Hints
export const WORD_DICTIONARY = {
  1: [ // 3-letter words
    { word: 'CAT', meaning: 'A small furry pet animal that says meow', hint: 'Pet that meows' },
    { word: 'DOG', meaning: 'A loyal pet animal that barks', hint: 'Pet that barks' },
    { word: 'SUN', meaning: 'The bright star that gives us light and warmth', hint: 'Shines in the sky' },
    { word: 'HAT', meaning: 'Something you wear on your head', hint: 'Wear on head' },
    { word: 'BAT', meaning: 'A flying mammal or sports equipment', hint: 'Flies at night' },
    { word: 'RAT', meaning: 'A small rodent with a long tail', hint: 'Small rodent' },
    { word: 'PEN', meaning: 'A tool used for writing with ink', hint: 'Writing tool' },
    { word: 'CUP', meaning: 'A container for drinking liquids', hint: 'Drink from this' },
    { word: 'BUS', meaning: 'A large vehicle that carries many passengers', hint: 'Public transport' },
    { word: 'BOX', meaning: 'A container with four sides and a lid', hint: 'Storage container' },
    { word: 'BEE', meaning: 'An insect that makes honey', hint: 'Makes honey' },
    { word: 'EGG', meaning: 'An oval object laid by birds', hint: 'Birds lay these' },
    { word: 'FOX', meaning: 'A wild animal with red fur and a bushy tail', hint: 'Clever animal' },
    { word: 'JAR', meaning: 'A glass container with a lid', hint: 'Glass container' },
    { word: 'KEY', meaning: 'Used to open locks', hint: 'Opens locks' },
  ],
  2: [ // 4-letter words
    { word: 'BOOK', meaning: 'Pages bound together for reading', hint: 'Read stories' },
    { word: 'TREE', meaning: 'A tall plant with branches and leaves', hint: 'Has branches' },
    { word: 'FISH', meaning: 'An animal that lives and swims in water', hint: 'Swims in water' },
    { word: 'BIRD', meaning: 'An animal with wings that can fly', hint: 'Has wings' },
    { word: 'STAR', meaning: 'A bright point of light in the night sky', hint: 'Twinkles at night' },
    { word: 'MOON', meaning: 'Earth\'s natural satellite that shines at night', hint: 'Shines at night' },
    { word: 'RAIN', meaning: 'Water falling from clouds', hint: 'Falls from clouds' },
    { word: 'WIND', meaning: 'Moving air that you can feel', hint: 'Moving air' },
    { word: 'SNOW', meaning: 'Frozen water that falls as white flakes', hint: 'White and cold' },
    { word: 'FIRE', meaning: 'Hot, bright flames that give heat', hint: 'Hot and bright' },
    { word: 'DOOR', meaning: 'An entrance to a room or building', hint: 'Room entrance' },
    { word: 'HAND', meaning: 'The part at the end of your arm', hint: 'Has five fingers' },
    { word: 'FOOT', meaning: 'The part at the end of your leg', hint: 'Walk with this' },
    { word: 'MILK', meaning: 'A white drink from cows', hint: 'White drink' },
    { word: 'CAKE', meaning: 'A sweet baked dessert', hint: 'Birthday treat' },
  ],
  3: [ // 5-letter words
    { word: 'APPLE', meaning: 'A round fruit that can be red, green, or yellow', hint: 'Round fruit' },
    { word: 'HOUSE', meaning: 'A building where people live', hint: 'Where you live' },
    { word: 'WATER', meaning: 'A clear liquid that we drink', hint: 'Clear liquid' },
    { word: 'PLANT', meaning: 'A living thing that grows in soil', hint: 'Grows in soil' },
    { word: 'CHAIR', meaning: 'Furniture for sitting', hint: 'Sit on this' },
    { word: 'TABLE', meaning: 'Furniture with a flat top for eating or working', hint: 'Eat meals here' },
    { word: 'PHONE', meaning: 'A device for talking to people far away', hint: 'Call people' },
    { word: 'CLOCK', meaning: 'A device that shows the time', hint: 'Shows time' },
    { word: 'LIGHT', meaning: 'Brightness that helps us see', hint: 'Helps us see' },
    { word: 'MUSIC', meaning: 'Pleasant sounds made by instruments or voices', hint: 'Pleasant sounds' },
    { word: 'BREAD', meaning: 'A baked food made from flour', hint: 'Made from flour' },
    { word: 'GRASS', meaning: 'Green plants that cover lawns', hint: 'Green on lawns' },
    { word: 'BEACH', meaning: 'Sandy area by the ocean', hint: 'Sandy shore' },
    { word: 'SMILE', meaning: 'A happy expression on your face', hint: 'Happy face' },
    { word: 'HEART', meaning: 'The organ that pumps blood', hint: 'Pumps blood' },
  ],
  4: [ // 6-letter words
    { word: 'SCHOOL', meaning: 'A place where children learn', hint: 'Place to learn' },
    { word: 'GARDEN', meaning: 'An area for growing flowers and vegetables', hint: 'Grow flowers' },
    { word: 'WINDOW', meaning: 'An opening in a wall with glass', hint: 'See through this' },
    { word: 'PENCIL', meaning: 'A tool for writing or drawing', hint: 'Writing tool' },
    { word: 'FLOWER', meaning: 'The colorful part of a plant', hint: 'Colorful plant' },
    { word: 'ANIMAL', meaning: 'A living creature that can move', hint: 'Living creature' },
    { word: 'PLANET', meaning: 'A large object in space that orbits a star', hint: 'Orbits the sun' },
    { word: 'ROCKET', meaning: 'A vehicle that travels to space', hint: 'Goes to space' },
    { word: 'CASTLE', meaning: 'A large building where kings and queens lived', hint: 'Royal building' },
    { word: 'BRIDGE', meaning: 'A structure built over water or roads', hint: 'Cross over water' },
    { word: 'FOREST', meaning: 'A large area covered with trees', hint: 'Many trees' },
    { word: 'MARKET', meaning: 'A place where people buy and sell things', hint: 'Buy and sell' },
    { word: 'FRIEND', meaning: 'Someone you like and enjoy being with', hint: 'Someone you like' },
    { word: 'FAMILY', meaning: 'Parents, children, and relatives', hint: 'Parents and kids' },
    { word: 'SUMMER', meaning: 'The warmest season of the year', hint: 'Hot season' },
  ],
  5: [ // 7-letter words
    { word: 'RAINBOW', meaning: 'Colorful arc in the sky after rain', hint: 'Seven colors' },
    { word: 'KITCHEN', meaning: 'Room where food is prepared', hint: 'Cook food here' },
    { word: 'BEDROOM', meaning: 'Room where you sleep', hint: 'Sleep here' },
    { word: 'LIBRARY', meaning: 'A place with many books to read', hint: 'Many books' },
    { word: 'PICTURE', meaning: 'An image or photograph', hint: 'Visual image' },
    { word: 'MONSTER', meaning: 'A scary imaginary creature', hint: 'Scary creature' },
    { word: 'DIAMOND', meaning: 'A precious sparkling gemstone', hint: 'Precious gem' },
    { word: 'VOLCANO', meaning: 'A mountain that can erupt with lava', hint: 'Erupts lava' },
    { word: 'DOLPHIN', meaning: 'An intelligent sea mammal', hint: 'Smart sea animal' },
    { word: 'GIRAFFE', meaning: 'A tall animal with a long neck', hint: 'Long neck' },
    { word: 'CHICKEN', meaning: 'A farm bird that lays eggs', hint: 'Lays eggs' },
    { word: 'BALLOON', meaning: 'A rubber bag filled with air', hint: 'Filled with air' },
    { word: 'BLANKET', meaning: 'A warm cover for your bed', hint: 'Bed cover' },
    { word: 'BROTHER', meaning: 'A male sibling', hint: 'Male sibling' },
    { word: 'TEACHER', meaning: 'A person who helps students learn', hint: 'Helps you learn' },
  ],
  6: [ // 8-letter words
    { word: 'ELEPHANT', meaning: 'The largest land animal with a trunk', hint: 'Has a trunk' },
    { word: 'MOUNTAIN', meaning: 'A very high natural elevation', hint: 'Very high land' },
    { word: 'COMPUTER', meaning: 'An electronic device for processing data', hint: 'Electronic device' },
    { word: 'BIRTHDAY', meaning: 'The anniversary of the day you were born', hint: 'Celebrate yearly' },
    { word: 'TREASURE', meaning: 'Valuable items like gold and jewels', hint: 'Valuable items' },
    { word: 'DINOSAUR', meaning: 'An extinct prehistoric reptile', hint: 'Prehistoric animal' },
    { word: 'SANDWICH', meaning: 'Food between two slices of bread', hint: 'Between bread' },
    { word: 'UMBRELLA', meaning: 'Protection from rain', hint: 'Rain protection' },
    { word: 'HOSPITAL', meaning: 'A place where sick people are treated', hint: 'Treat sick people' },
    { word: 'AIRPLANE', meaning: 'A flying vehicle with wings', hint: 'Flies in sky' },
    { word: 'FOOTBALL', meaning: 'A popular team sport with a ball', hint: 'Team sport' },
    { word: 'PRINCESS', meaning: 'A daughter of a king or queen', hint: 'Royal daughter' },
    { word: 'CALENDAR', meaning: 'Shows days, weeks, and months', hint: 'Shows dates' },
    { word: 'BACKPACK', meaning: 'A bag carried on your back', hint: 'Carry on back' },
    { word: 'KEYBOARD', meaning: 'Device with keys for typing', hint: 'For typing' },
  ],
  7: [ // 10-letter words
    { word: 'BASKETBALL', meaning: 'A sport played with a ball and hoops', hint: 'Sport with hoops' },
    { word: 'PLAYGROUND', meaning: 'An outdoor area for children to play', hint: 'Kids play here' },
    { word: 'WATERMELON', meaning: 'A large juicy fruit with red flesh', hint: 'Large juicy fruit' },
    { word: 'CALCULATOR', meaning: 'A device for doing math calculations', hint: 'Does math' },
    { word: 'HELICOPTER', meaning: 'An aircraft with rotating blades', hint: 'Rotating blades' },
    { word: 'SKATEBOARD', meaning: 'A board with wheels for riding', hint: 'Board with wheels' },
    { word: 'STRAWBERRY', meaning: 'A small red fruit with seeds outside', hint: 'Red berry' },
    { word: 'TRAMPOLINE', meaning: 'A bouncy surface for jumping', hint: 'Jump and bounce' },
    { word: 'MOTORCYCLE', meaning: 'A two-wheeled motor vehicle', hint: 'Two-wheel vehicle' },
    { word: 'RESTAURANT', meaning: 'A place where meals are served', hint: 'Eat meals out' },
    { word: 'TELEVISION', meaning: 'An electronic device for watching shows', hint: 'Watch shows' },
    { word: 'BLACKBOARD', meaning: 'A dark board for writing with chalk', hint: 'Write with chalk' },
    { word: 'TOOTHBRUSH', meaning: 'A tool for cleaning teeth', hint: 'Clean teeth' },
    { word: 'FLASHLIGHT', meaning: 'A portable electric light', hint: 'Portable light' },
    { word: 'SUNGLASSES', meaning: 'Dark glasses to protect from sun', hint: 'Protect from sun' },
  ],
  8: [ // 12+ letter words
    { word: 'MATHEMATICS', meaning: 'The study of numbers and calculations', hint: 'Study of numbers' },
    { word: 'ENCYCLOPEDIA', meaning: 'A book with information on many subjects', hint: 'Book of knowledge' },
    { word: 'REFRIGERATOR', meaning: 'An appliance that keeps food cold', hint: 'Keeps food cold' },
    { word: 'CONSTELLATION', meaning: 'A group of stars forming a pattern', hint: 'Star pattern' },
    { word: 'MULTIPLICATION', meaning: 'A math operation of repeated addition', hint: 'Math operation' },
    { word: 'EXTRAORDINARY', meaning: 'Very unusual or remarkable', hint: 'Very remarkable' },
    { word: 'COMMUNICATION', meaning: 'The exchange of information', hint: 'Exchange info' },
    { word: 'TRANSPORTATION', meaning: 'The movement of people or goods', hint: 'Moving people' },
    { word: 'INVESTIGATION', meaning: 'A detailed examination or study', hint: 'Detailed study' },
    { word: 'DETERMINATION', meaning: 'Firmness of purpose', hint: 'Strong will' },
    { word: 'NEIGHBORHOOD', meaning: 'An area where people live near each other', hint: 'Local area' },
    { word: 'THANKSGIVING', meaning: 'A holiday for giving thanks', hint: 'Holiday of thanks' },
    { word: 'CHAMPIONSHIP', meaning: 'A competition to find the best', hint: 'Top competition' },
    { word: 'INDEPENDENCE', meaning: 'Freedom from control', hint: 'Being free' },
    { word: 'APPRECIATION', meaning: 'Recognition of value or quality', hint: 'Showing gratitude' },
  ]
};

// Track used words to avoid repetition
export const usedWordsTracker = {
  1: new Set(),
  2: new Set(),
  3: new Set(),
  4: new Set(),
  5: new Set(),
  6: new Set(),
  7: new Set(),
  8: new Set()
};

export const getRandomWord = (level) => {
  const levelWords = WORD_DICTIONARY[level];
  const usedWords = usedWordsTracker[level];
  
  // Reset if all words have been used
  if (usedWords.size >= levelWords.length) {
    usedWords.clear();
  }
  
  // Find unused words
  const availableWords = levelWords.filter(w => !usedWords.has(w.word));
  
  // Pick random word
  const wordData = availableWords[Math.floor(Math.random() * availableWords.length)];
  usedWords.add(wordData.word);
  
  return wordData;
};

export const resetUsedWords = () => {
  Object.keys(usedWordsTracker).forEach(level => {
    usedWordsTracker[level].clear();
  });
};
